// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 249 ? "views-home" : chunkId) + "." + {"249":"4359fae6","466":"140af830","891":"f170cdc3"}[chunkId] + ".chunk.css";
};